// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RadgivningRouteImport } from './routes/radgivning'
import { Route as PriserRouteImport } from './routes/priser'
import { Route as OmOssRouteImport } from './routes/om-oss'
import { Route as MedarbetareRouteImport } from './routes/medarbetare'
import { Route as LoneadministrationRouteImport } from './routes/loneadministration'
import { Route as KontaktUmeaRouteImport } from './routes/kontakt-umea'
import { Route as KontaktStockholmRouteImport } from './routes/kontakt-stockholm'
import { Route as KontaktRouteImport } from './routes/kontakt'
import { Route as KarriarRouteImport } from './routes/karriar'
import { Route as IntegritetspolicyRouteImport } from './routes/integritetspolicy'
import { Route as InhouseRouteImport } from './routes/inhouse'
import { Route as BytaRedovisningsbyraRouteImport } from './routes/byta-redovisningsbyra'
import { Route as BokslutRouteImport } from './routes/bokslut'
import { Route as BokforingUmeaRouteImport } from './routes/bokforing-umea'
import { Route as BokforingStockholmRouteImport } from './routes/bokforing-stockholm'
import { Route as BokforingRouteImport } from './routes/bokforing'
import { Route as ArsredovisningAktiebolagRouteImport } from './routes/arsredovisning-aktiebolag'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as NyheterIndexRouteImport } from './routes/nyheter/index'
import { Route as KundreferenserIndexRouteImport } from './routes/kundreferenser/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as NyheterSlugRouteImport } from './routes/nyheter/$slug'
import { Route as KundreferenserSlugRouteImport } from './routes/kundreferenser/$slug'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminTestimonialsRouteImport } from './routes/admin/testimonials'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminServicesRouteImport } from './routes/admin/services'
import { Route as AdminPagesRouteImport } from './routes/admin/pages'
import { Route as AdminNewsTeasersRouteImport } from './routes/admin/news-teasers'
import { Route as AdminLoginRouteImport } from './routes/admin/login'
import { Route as AdminIntegrationsRouteImport } from './routes/admin/integrations'
import { Route as AdminFormsRouteImport } from './routes/admin/forms'
import { Route as AdminCaseStudiesRouteImport } from './routes/admin/case-studies'
import { Route as AdminTeamMembersIndexRouteImport } from './routes/admin/team-members/index'
import { Route as AdminJobsIndexRouteImport } from './routes/admin/jobs/index'
import { Route as AdminArticlesIndexRouteImport } from './routes/admin/articles/index'
import { Route as AdminTeamMembersIdRouteImport } from './routes/admin/team-members/$id'
import { Route as AdminJobsIdRouteImport } from './routes/admin/jobs/$id'
import { Route as AdminArticlesIdRouteImport } from './routes/admin/articles/$id'
import { Route as AdminPagesIdRouteImport } from './routes/admin/pages/$id'

const RadgivningRoute = RadgivningRouteImport.update({
            id: '/radgivning',path: '/radgivning',getParentRoute: () => rootRouteImport
          })
const PriserRoute = PriserRouteImport.update({
            id: '/priser',path: '/priser',getParentRoute: () => rootRouteImport
          })
const OmOssRoute = OmOssRouteImport.update({
            id: '/om-oss',path: '/om-oss',getParentRoute: () => rootRouteImport
          })
const MedarbetareRoute = MedarbetareRouteImport.update({
            id: '/medarbetare',path: '/medarbetare',getParentRoute: () => rootRouteImport
          })
const LoneadministrationRoute = LoneadministrationRouteImport.update({
            id: '/loneadministration',path: '/loneadministration',getParentRoute: () => rootRouteImport
          })
const KontaktUmeaRoute = KontaktUmeaRouteImport.update({
            id: '/kontakt-umea',path: '/kontakt-umea',getParentRoute: () => rootRouteImport
          })
const KontaktStockholmRoute = KontaktStockholmRouteImport.update({
            id: '/kontakt-stockholm',path: '/kontakt-stockholm',getParentRoute: () => rootRouteImport
          })
const KontaktRoute = KontaktRouteImport.update({
            id: '/kontakt',path: '/kontakt',getParentRoute: () => rootRouteImport
          })
const KarriarRoute = KarriarRouteImport.update({
            id: '/karriar',path: '/karriar',getParentRoute: () => rootRouteImport
          })
const IntegritetspolicyRoute = IntegritetspolicyRouteImport.update({
            id: '/integritetspolicy',path: '/integritetspolicy',getParentRoute: () => rootRouteImport
          })
const InhouseRoute = InhouseRouteImport.update({
            id: '/inhouse',path: '/inhouse',getParentRoute: () => rootRouteImport
          })
const BytaRedovisningsbyraRoute = BytaRedovisningsbyraRouteImport.update({
            id: '/byta-redovisningsbyra',path: '/byta-redovisningsbyra',getParentRoute: () => rootRouteImport
          })
const BokslutRoute = BokslutRouteImport.update({
            id: '/bokslut',path: '/bokslut',getParentRoute: () => rootRouteImport
          })
const BokforingUmeaRoute = BokforingUmeaRouteImport.update({
            id: '/bokforing-umea',path: '/bokforing-umea',getParentRoute: () => rootRouteImport
          })
const BokforingStockholmRoute = BokforingStockholmRouteImport.update({
            id: '/bokforing-stockholm',path: '/bokforing-stockholm',getParentRoute: () => rootRouteImport
          })
const BokforingRoute = BokforingRouteImport.update({
            id: '/bokforing',path: '/bokforing',getParentRoute: () => rootRouteImport
          })
const ArsredovisningAktiebolagRoute = ArsredovisningAktiebolagRouteImport.update({
            id: '/arsredovisning-aktiebolag',path: '/arsredovisning-aktiebolag',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const NyheterIndexRoute = NyheterIndexRouteImport.update({
            id: '/nyheter/',path: '/nyheter/',getParentRoute: () => rootRouteImport
          })
const KundreferenserIndexRoute = KundreferenserIndexRouteImport.update({
            id: '/kundreferenser/',path: '/kundreferenser/',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const NyheterSlugRoute = NyheterSlugRouteImport.update({
            id: '/nyheter/$slug',path: '/nyheter/$slug',getParentRoute: () => rootRouteImport
          })
const KundreferenserSlugRoute = KundreferenserSlugRouteImport.update({
            id: '/kundreferenser/$slug',path: '/kundreferenser/$slug',getParentRoute: () => rootRouteImport
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/admin/users',path: '/admin/users',getParentRoute: () => rootRouteImport
          })
const AdminTestimonialsRoute = AdminTestimonialsRouteImport.update({
            id: '/admin/testimonials',path: '/admin/testimonials',getParentRoute: () => rootRouteImport
          })
const AdminSettingsRoute = AdminSettingsRouteImport.update({
            id: '/admin/settings',path: '/admin/settings',getParentRoute: () => rootRouteImport
          })
const AdminServicesRoute = AdminServicesRouteImport.update({
            id: '/admin/services',path: '/admin/services',getParentRoute: () => rootRouteImport
          })
const AdminPagesRoute = AdminPagesRouteImport.update({
            id: '/admin/pages',path: '/admin/pages',getParentRoute: () => rootRouteImport
          })
const AdminNewsTeasersRoute = AdminNewsTeasersRouteImport.update({
            id: '/admin/news-teasers',path: '/admin/news-teasers',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin/login',path: '/admin/login',getParentRoute: () => rootRouteImport
          })
const AdminIntegrationsRoute = AdminIntegrationsRouteImport.update({
            id: '/admin/integrations',path: '/admin/integrations',getParentRoute: () => rootRouteImport
          })
const AdminFormsRoute = AdminFormsRouteImport.update({
            id: '/admin/forms',path: '/admin/forms',getParentRoute: () => rootRouteImport
          })
const AdminCaseStudiesRoute = AdminCaseStudiesRouteImport.update({
            id: '/admin/case-studies',path: '/admin/case-studies',getParentRoute: () => rootRouteImport
          })
const AdminTeamMembersIndexRoute = AdminTeamMembersIndexRouteImport.update({
            id: '/admin/team-members/',path: '/admin/team-members/',getParentRoute: () => rootRouteImport
          })
const AdminJobsIndexRoute = AdminJobsIndexRouteImport.update({
            id: '/admin/jobs/',path: '/admin/jobs/',getParentRoute: () => rootRouteImport
          })
const AdminArticlesIndexRoute = AdminArticlesIndexRouteImport.update({
            id: '/admin/articles/',path: '/admin/articles/',getParentRoute: () => rootRouteImport
          })
const AdminTeamMembersIdRoute = AdminTeamMembersIdRouteImport.update({
            id: '/admin/team-members/$id',path: '/admin/team-members/$id',getParentRoute: () => rootRouteImport
          })
const AdminJobsIdRoute = AdminJobsIdRouteImport.update({
            id: '/admin/jobs/$id',path: '/admin/jobs/$id',getParentRoute: () => rootRouteImport
          })
const AdminArticlesIdRoute = AdminArticlesIdRouteImport.update({
            id: '/admin/articles/$id',path: '/admin/articles/$id',getParentRoute: () => rootRouteImport
          })
const AdminPagesIdRoute = AdminPagesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminPagesRoute
          })





const AdminPagesRouteChildren = {
  AdminPagesIdRoute: AdminPagesIdRoute
}

const AdminPagesRouteWithChildren = AdminPagesRoute._addFileChildren(AdminPagesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,ArsredovisningAktiebolagRoute: ArsredovisningAktiebolagRoute,BokforingRoute: BokforingRoute,BokforingStockholmRoute: BokforingStockholmRoute,BokforingUmeaRoute: BokforingUmeaRoute,BokslutRoute: BokslutRoute,BytaRedovisningsbyraRoute: BytaRedovisningsbyraRoute,InhouseRoute: InhouseRoute,IntegritetspolicyRoute: IntegritetspolicyRoute,KarriarRoute: KarriarRoute,KontaktRoute: KontaktRoute,KontaktStockholmRoute: KontaktStockholmRoute,KontaktUmeaRoute: KontaktUmeaRoute,LoneadministrationRoute: LoneadministrationRoute,MedarbetareRoute: MedarbetareRoute,OmOssRoute: OmOssRoute,PriserRoute: PriserRoute,RadgivningRoute: RadgivningRoute,AdminCaseStudiesRoute: AdminCaseStudiesRoute,AdminFormsRoute: AdminFormsRoute,AdminIntegrationsRoute: AdminIntegrationsRoute,AdminLoginRoute: AdminLoginRoute,AdminNewsTeasersRoute: AdminNewsTeasersRoute,AdminPagesRoute: AdminPagesRouteWithChildren,AdminServicesRoute: AdminServicesRoute,AdminSettingsRoute: AdminSettingsRoute,AdminTestimonialsRoute: AdminTestimonialsRoute,AdminUsersRoute: AdminUsersRoute,KundreferenserSlugRoute: KundreferenserSlugRoute,NyheterSlugRoute: NyheterSlugRoute,AdminIndexRoute: AdminIndexRoute,KundreferenserIndexRoute: KundreferenserIndexRoute,NyheterIndexRoute: NyheterIndexRoute,AdminArticlesIdRoute: AdminArticlesIdRoute,AdminJobsIdRoute: AdminJobsIdRoute,AdminTeamMembersIdRoute: AdminTeamMembersIdRoute,AdminArticlesIndexRoute: AdminArticlesIndexRoute,AdminJobsIndexRoute: AdminJobsIndexRoute,AdminTeamMembersIndexRoute: AdminTeamMembersIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)